var map = {
	"./cloud.svg": "EGW8",
	"./facebook.svg": "6nEl",
	"./fyrirtaeki.svg": "tC+z",
	"./heimili.svg": "2LwC",
	"./s.svg": "9R1b",
	"./skofla.svg": "YUHJ",
	"./wifi.svg": "sYcl",
	"./youtube.svg": "FxBP"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Vjsg";